import { render } from "./LoadExternalTranslations.vue?vue&type=template&id=9f7abad6&scoped=true&ts=true"
import script from "./LoadExternalTranslations.vue?vue&type=script&lang=ts"
export * from "./LoadExternalTranslations.vue?vue&type=script&lang=ts"

import "./LoadExternalTranslations.vue?vue&type=style&index=0&id=9f7abad6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f7abad6"]])

export default __exports__